import { useState } from "react";
import Modal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

var MonitorApi = require('monitor-api');

export default function EiuUpdate({ rowEntry, reloadData, instance }) {
    const [showModal, setShowModal] = useState(false);
    const [inputs, setInputs] = useState({});
    const [update, setUpdate] = useState(new MonitorApi.EisenbahninfraunternehmenUpdate());
    const [upAvailable, setUpAvailable] = useState(false);

    const openModal = event => {
        setInputs({
            eiu: rowEntry.original.eiu,
            kurz: rowEntry.original.kurz
        });
        setUpdate(pre => ({ ...pre, "eiuId": rowEntry.original.id }));
        setShowModal(true);
        setUpAvailable(false);
    }

    const closeModal = () => {
        setUpdate({});
        setShowModal(false);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const changeEntry = event => {
        setUpAvailable(true);
        setUpdate(old => ({ ...old, [event.target.id]: event.target.value }));
    }

    const saveChanges = event => {
        event.preventDefault();
        let result = new Promise((resolve) =>
            instance.updateEiuEisenbahninfraunternehmenEiuIdPatch(update, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Änderungen gespeichert`);
                    resolve(data);
                }
            }))
        result.then((msg) => {
            closeModal();
            reloadData();
        })
    }
    return (
        <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saveChanges}>
                    <h3>Änderungen eintragen:</h3>
                    <MyModalContentRow>
                        {<label>Bezeichnung:
                            <MyModalContentTextInput id="eiu"
                                onChange={changeEntry}
                                value={update.eiu ? update.eiu : inputs.eiu} />
                        </label>}
                    </MyModalContentRow>
                    <MyModalContentRow>
                        {<label>Abkürzung:
                            <MyModalContentTextInput id="kurz"
                                onChange={changeEntry}
                                value={update.kurz ? update.kurz : inputs.kurz} />
                        </label>}
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton disabled={!upAvailable} type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbrechen</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </>)
}